import styled from "styled-components";
import {useDispatch,useSelector} from 'react-redux';
import {logout,data,instal,dataRutas} from '../redux/actions.js';
import {Outlet,useNavigate,NavLink} from 'react-router-dom'
import {getData,getRutas } from "../services/authentication.js"
import {mobile} from  "../services/services.js"
import logo2 from '../imgs/logosinfondo.png';
import React from 'react'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { baseURLCompartido } from "../services/authentication.js"



export const LogoFarmasis=styled.img`
	width:90px;
	position:relative;
	left:35px;
	top:8px;
	@media (max-width:500px){
		      top:5px;
					left:9px;
					width:70px}
`;


const UserName=styled.span`
  font-size:20px;
  font-weight: bold;
	color:#033953;
	@media (max-width:600px){
					font-size:15px};
  @media (max-width:400px){
					font-size:13px};
`
	


const InicialLetter=styled.div`
	background-color:purple;
	width: 40px;
  height:40px; 
  border-radius:45px;
  margin:5px;
  font-size:22px;
  color:white;
  display:flex;
  justify-content:center;
  align-items:center;
  @media (max-width:600px){
          font-size:20px;
          width:35px;
          height:35px};
  @media (max-width:300px){
          font-size:10px;
          width:20px;
          height:20px}
`;

export const Navbar=styled.div`
  background-color:#F7F6F6;
`
const UserInfo=styled.div`
	position: absolute;
	right:10px;
	top:1px;
	display: flex;
	margin:5px;
	@media (max-width:600px){
					top:5px}
`;


const Logout=styled.div`
	position: absolute;
	right:50px;
	top:22px;
	color:red;
	font-size:18px;
	font-weight:bold;
	@media (max-width:600px){
					top:40%;
					right:60px;
					font-size:15px};
	@media (max-width:300px){
          font-size:13px;
          right:30px}
`






export default function Home(){
	const navigate = useNavigate();
	let dispatch=useDispatch();
	let isLogin=useSelector(state=>state.isloguin);
	let user=useSelector(state=>state.usuario);
	let grupo=useSelector(state=>state.grupo);
	const [value, setValue] = React.useState(0);
	

	
	const handleChange=(e,newValue)=>{ setValue(newValue)	};
	let handleLogout=()=>{dispatch(logout());dispatch(instal(false)); navigate("/") };

	React.useEffect(()=>{
		let carga=async()=>{
			try{				
					let datos=await getData();
					let DAtaRutas=await getRutas();
    			dispatch(data(datos));
    			dispatch(dataRutas(DAtaRutas))

			}catch(err){alert("sesion expirada");console.log(err);window.location.replace(baseURLCompartido)}
  	};

		carga();

	},[dispatch])


	React.useEffect(()=>{
 	  
  		if(isLogin==="false"||isLogin===false) {navigate("/")} 

  },[isLogin,navigate])



	return (
	<div>
		<Navbar>
		  	<a style={{width:"20vw"}} href ="https://www.farmasis.site/farmasis/index.html" target="blank"><LogoFarmasis src={logo2} alt="logocfc" /></a>
		 		
		       <UserInfo>
		      	  {user?<UserName>Bienvenido: {user}</UserName>:null}
		      	  {user?<InicialLetter>{user[0].toUpperCase()}</InicialLetter>:null}
		     	   <Logout><span onClick={handleLogout} >Logout</span></Logout>
		       </UserInfo>		
	     	
	     	<div style={{height:"5px"}}>
	     		
	     	</div>
	     	<Box>
	     		<Tabs   value={value} onChange={handleChange} component={NavLink}  style={{ textDecoration: "none" }} textColor="primary" indicatorColor="primary" allowScrollButtonsMobile scrollButtons variant="scrollable" >
        		<Tab label="tutoriales" to={`/Home/Tutoriales/${grupo}`} component={NavLink} />
        		<Tab label="Speed test" to="/Home/Velocidad" component={NavLink} />	
        		<Tab label="consulta SUNAT"  to="/Home/ConsultaValidez" component={NavLink} />
       		 	{mobile()?null:<Tab label="DIGEMID" to="/Home/digemid" component={NavLink} />}
       		 	<Tab label="Referidos" to="/Home/Referidos" component={NavLink} />
       		 	{user==="Cesarin"?<Tab label="subir video" to="/Home/Upload"  component={NavLink} />:null }
      		</Tabs>
      	</Box>
	 
       

       

		</Navbar>
		 <Outlet />
	</div>

		)
}
